import { render, staticRenderFns } from "./BasePageDescriptionPanel.vue?vue&type=template&id=1b56703c&scoped=true"
import script from "./BasePageDescriptionPanel.vue?vue&type=script&lang=js"
export * from "./BasePageDescriptionPanel.vue?vue&type=script&lang=js"
import style0 from "./BasePageDescriptionPanel.vue?vue&type=style&index=0&id=1b56703c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b56703c",
  null
  
)

export default component.exports